export default "__VITE_ASSET__b170f7ff__"